import Page from "../components/page";
import config from "../configs";

const About = () => {
  return (
    <Page title={`About - ${config.appName}`} hideLoader>
      <div className="info-page">
        <p>
          Here’s a unique rewrite of your content while maintaining the original
          intent:
        </p>
        <hr />
        <h3>
          <strong>
            {config.appName} – Your Go-To Platform for HD Movie Downloads
          </strong>
        </h3>
        <p>
          {config.appName} is a premier destination for downloading{" "}
          <strong>Bollywood and Hollywood movies</strong> in{" "}
          <strong>720p HD quality</strong>. We provide{" "}
          <strong>direct download links</strong> with{" "}
          <strong>no annoying ads or pop-ups</strong>, ensuring a smooth
          experience for users.
        </p>
        <p>
          We offer multiple <strong>file-sharing site links</strong> for each
          movie, available in various formats like{" "}
          <strong>BluRay, HDRip, BRRip, Web-DL</strong>, and more.
        </p>
        <h4>
          <strong>What You Can Download from {config.appName}:</strong>
        </h4>
        <ul>
          <li>
            ✅ <strong>Hindi Movies</strong>
          </li>
          <li>
            ✅ <strong>300MB Movies, 480p, 720p, 1080p Movies</strong>
          </li>
          <li>
            ✅{" "}
            <strong>
              Dual/Multiple Audio High-Quality Movies &amp; TV/Web Series
            </strong>
          </li>
          <li>
            ✅ <strong>English Movies &amp; Hollywood Dual Audio Movies</strong>
          </li>
          <li>
            ✅{" "}
            <strong>
              Bollywood Movies, TV Shows, Web Series, Anime, and More
            </strong>
          </li>
        </ul>
        <p>
          Enjoy <strong>fast, direct downloads</strong> without pop-ups or
          unwanted redirections!
        </p>
        <hr />
        <h3>
          <strong>Disclaimer</strong>
        </h3>
        <p>
          All content shared on <strong>{config.appName}</strong> is freely
          available on the internet and has been{" "}
          <strong>posted by external sources</strong>. We do not host any files
          on our own servers.
        </p>
        <h4>
          <strong>Copyright Policy:</strong>
        </h4>
        <p>
          We respect copyright laws. If you believe your content has been shared
          without permission, you can{" "}
          <strong>submit a claim via our DMCA Contact Form</strong>.
        </p>
        <p>
          📩 <strong>For Copyright Concerns:</strong> Contact us at{" "}
          <strong>
            <a href="mailto:voiseries@protonmail.com">
              voiseries@protonmail.com
            </a>
          </strong>
        </p>
        <p>
          💡 <strong>Note:</strong>{" "}
          <strong>
            {config.appName} operates independently and has no affiliation with
            third-party content hosts.
          </strong>
        </p>
      </div>
    </Page>
  );
};

export default About;
